app.controller('OrganizationalUnitEditController', [
  '$scope', '$uibModalInstance', 'params', 'OrganizationalUnit', 'StaticData', 'toastr',
  function ($scope, $uibModalInstance, params, OrganizationalUnit, StaticData, toastr) {
    $scope.choosedFaculty = null;
    $scope.data = {
      name: params.name,
      faculties: params.faculties || []
    }
    $scope.facultiesMap;
    $scope.faculties;

    StaticData.getItemsByKey("faculties").then(function (faculties) {
      $scope.faculties = [{ name: "ფაკულტეტი" }].concat(faculties);
      $scope.facultiesMap = _.keyBy($scope.faculties, '_id');

    });

    $scope.changeFaculty = function () {
      if (!$scope.choosedFaculty) return
      var found = $scope.data.faculties.find(function (f) { return f == $scope.choosedFaculty });
      if (found) return;
      else $scope.data.faculties.push($scope.choosedFaculty)
    }

    $scope.submit = function () {
      var data = $scope.data;
      var id = params.id;
      return OrganizationalUnit.change(id, data).then(function (data, err) {
        $uibModalInstance.close();
      }, function (err) {
        if (err) toastr.error(err.data);
      });
    };

    $scope.removeFaculty = function (faculty) {
      $scope.data.faculties = $scope.data.faculties.filter(function (f) { return f !== faculty });
    }

    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }
])
